import React, { useEffect, useRef, useState } from 'react'
import Main from '../Main'
import { Col, Row } from 'react-bootstrap'
import '../../assets/css/dashboard.scss'
import totalSla from '../../assets/images/Sla/totalSla.svg'
import inProcess from '../../assets/images/Sla/slaInProcess.svg'
import hold from '../../assets/images/Sla/slaHold.svg'
import completed from '../../assets/images/Sla/slaCompleted.svg'
import Download from '../MainSection/Download/Download'
import RelationshipTypeChart from '../Graphs/RelationshipTypeChart'
import FunnelChart from '../Graphs/FunnelChart'
import AttendanceStatusChart from '../Graphs/AttendanceStatusChart'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { loadAssignedToSlaTypeDropdownData, loadCompanyDropdownData, loadReportingToDropdownData, loadSLADashboardAssignedScoreData, loadSLADashboardCardData, loadSLADashboardChecklistStatusChartData, loadSLADashboardSlaTypesChartData, loadSLADashboardSlaTypeStatusChartData, loadUserDropdownData } from '../../redux/action'
import Skeleton from 'react-loading-skeleton'
import loader from '../../../src/assets/images/Dashboard/loader.gif'

function ServiceLevelAgreementDashboard() {
    let dispatch = useDispatch();
    const navigate = useNavigate();

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyId = signInDetails ? signInDetails[0].CompanyID : null
    const storedCompanyName = signInDetails ? signInDetails[0].CompanyName : null

    const { getCompanyDropdown } = useSelector((state) => state.data);
    const { reportingToDropdown } = useSelector((state) => state.data);
    const { getUserDropdown } = useSelector((state) => state.data);
    const { assignedToSlaTypeDropdownData } = useSelector((state) => state.data);
    const { getSlaDashboardCardData } = useSelector((state) => state.data);
    const { getSlaDashboardSlaTypeStatusChartData } = useSelector((state) => state.data);
    const { getSlaDashboardSlaTypesChartData } = useSelector((state) => state.data);
    const { getSlaDashboardChecklistStatusChartData } = useSelector((state) => state.data);
    const { customViews = [] } = useSelector((state) => state.data);

    const currentYear = new Date().getFullYear();
    const [loading, setLoading] = useState(true);
    const [selectedDashboardID, setSelectedDashboardID] = useState(null);

    const [selectedOptionForSlaType, setSelectedOptionForSlaType] = useState({
        // company: storedCompanyId || 'Company Name',
        company: { id: storedCompanyId, name: storedCompanyName },
        assignedTo: null,
        assignedToId: null,
        slaType: null,
        slaTypeId: null,
        year: currentYear || 'Year'
    });
    const [selectedOptionForSlaTypeStatus, setSelectedOptionForSlaTypeStatus] = useState({
        // company: storedCompanyId || 'Company Name',
        company: { id: storedCompanyId, name: storedCompanyName },
        assignedTo: null,
        assignedToId: null,
        slaType: null,
        slaTypeId: null,
        year: currentYear || 'Year'
    });
    const [selectedOptionForSlaChecklistStatus, setSelectedOptionForSlaChecklistStatus] = useState({
        // company: storedCompanyId || 'Company Name',
        company: { id: storedCompanyId, name: storedCompanyName },
        assignedTo: null,
        assignedToId: null,
        slaType: null,
        slaTypeId: null,
        year: currentYear || 'Year'
    });

    useEffect(() => {
        dispatch(loadCompanyDropdownData());
        dispatch(loadReportingToDropdownData());
        dispatch(loadUserDropdownData());
        dispatch(loadAssignedToSlaTypeDropdownData());
        dispatch(loadSLADashboardCardData(setLoading))
    }, []);

    useEffect(() => {
        if (selectedOptionForSlaTypeStatus.company && selectedOptionForSlaTypeStatus.year) {
            // Dispatch action with selectedOption (including companyId and year)
            dispatch(loadSLADashboardSlaTypeStatusChartData(selectedOptionForSlaTypeStatus.company.id, selectedOptionForSlaTypeStatus.assignedToId, selectedOptionForSlaTypeStatus.slaTypeId, selectedOptionForSlaTypeStatus.year));
        }
    }, [selectedOptionForSlaTypeStatus, dispatch]);

    useEffect(() => {
        if (selectedOptionForSlaType.company && selectedOptionForSlaType.year) {
            // Dispatch action with selectedOption (including companyId and year)
            dispatch(loadSLADashboardSlaTypesChartData(selectedOptionForSlaType.company.id, selectedOptionForSlaType.assignedToId, selectedOptionForSlaType.slaTypeId, selectedOptionForSlaType.year));
        }
    }, [selectedOptionForSlaType, dispatch]);

    useEffect(() => {
        if (selectedOptionForSlaChecklistStatus.company && selectedOptionForSlaChecklistStatus.year) {
            // Dispatch action with selectedOption (including companyId and year)
            dispatch(loadSLADashboardChecklistStatusChartData(selectedOptionForSlaChecklistStatus.company.id, selectedOptionForSlaChecklistStatus.assignedToId, selectedOptionForSlaChecklistStatus.slaTypeId, selectedOptionForSlaChecklistStatus.year));
        }
    }, [selectedOptionForSlaChecklistStatus, dispatch]);

    // Function to generate an array of years from 2020 to current year
    function generateYearRange(startYear) {
        const currentYear = new Date().getFullYear();  // Get current year dynamically
        const years = [];

        // Generate years from startYear to currentYear
        for (let year = startYear; year <= currentYear; year++) {
            years.push({ value: year, label: year });
        }

        return years;
    }

    const handleSelect = (eventKey, type, graphType) => {
        let selectedOption = null;

        if (graphType === 'SlaTypesStatus' || graphType === 'SlaTypes' || graphType === 'SlaChecklistStatus') {
            let dropdownData;
            let stateSetter;

            if (graphType === 'SlaTypesStatus') {
                dropdownData = type === 'company' ? getCompanyDropdown :
                    type === 'assignedTo' ? getUserDropdown :
                        type === 'slaType' ? assignedToSlaTypeDropdownData :
                            type === 'year' ? dropdownOptions.year.items : [];
                stateSetter = setSelectedOptionForSlaTypeStatus;
            } else if (graphType === 'SlaTypes') {
                dropdownData = type === 'company' ? getCompanyDropdown :
                    type === 'assignedTo' ? getUserDropdown :
                        type === 'slaType' ? assignedToSlaTypeDropdownData :
                            type === 'year' ? dropdownOptions.year.items : [];
                stateSetter = setSelectedOptionForSlaType;
            } else if (graphType === 'SlaChecklistStatus') {
                dropdownData = type === 'company' ? getCompanyDropdown :
                    type === 'assignedTo' ? getUserDropdown :
                        type === 'slaType' ? assignedToSlaTypeDropdownData :
                            type === 'year' ? dropdownOptions.year.items : [];
                stateSetter = setSelectedOptionForSlaChecklistStatus;
            }

            // Find the selected option
            if (dropdownData && dropdownData.length > 0) {
                selectedOption = dropdownData.find(item => item.value === Number(eventKey)); // Convert to number
            }

            if (selectedOption) {
                // Update state with the selected option
                const updateData = { ...selectedOption };

                if (type === 'company') {
                    stateSetter(prev => ({
                        ...prev,
                        company: { id: selectedOption.value, name: selectedOption.label }
                    }));
                } else if (type === 'assignedTo') {
                    stateSetter(prev => ({
                        ...prev,
                        assignedTo: selectedOption.label,
                        assignedToId: selectedOption.value
                    }));
                } else if (type === 'slaType') {
                    stateSetter(prev => ({
                        ...prev,
                        slaType: selectedOption.label,
                        slaTypeId: selectedOption.value
                    }));
                } else if (type === 'year') {
                    stateSetter(prev => ({
                        ...prev,
                        year: selectedOption.value
                    }));
                }
            } else {
                console.log(`No ${type} found matching the eventKey`);
            }
        }
    };


    const labels = ['Below < 40%', '40 - 70%', 'Above > 70%'];
    const colors = [
        'rgba(255, 94, 94, 1)',  // High
        'rgba(255, 159, 0, 1)',  // Medium
        'rgba(58, 201, 119, 1)', // Low
    ];
    const data = [30, 40, 50];

    const ComplaintLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const datasets = [
        {
            type: 'bar',
            label: 'Hold',
            data: [getSlaDashboardSlaTypeStatusChartData?.JanOnHold,
            getSlaDashboardSlaTypeStatusChartData?.FebOnHold,
            getSlaDashboardSlaTypeStatusChartData?.MarOnHold,
            getSlaDashboardSlaTypeStatusChartData?.AprOnHold,
            getSlaDashboardSlaTypeStatusChartData?.MayOnHold,
            getSlaDashboardSlaTypeStatusChartData?.JunOnHold,
            getSlaDashboardSlaTypeStatusChartData?.JulOnHold,
            getSlaDashboardSlaTypeStatusChartData?.AugOnHold,
            getSlaDashboardSlaTypeStatusChartData?.SepOnHold,
            getSlaDashboardSlaTypeStatusChartData?.OctOnHold,
            getSlaDashboardSlaTypeStatusChartData?.NovOnHold,
            getSlaDashboardSlaTypeStatusChartData?.DecOnHold
            ],
            backgroundColor: 'rgba(240, 207, 43, 1)', // Yellow
            borderColor: 'rgba(240, 207, 43, 1)',
            borderWidth: 1,
            borderRadius: 4,
            barThickness: 8,
            borderSkipped: false,
        },
        {
            type: 'bar',
            label: 'Inprogress',
            data: [getSlaDashboardSlaTypeStatusChartData?.JanInProcess,
            getSlaDashboardSlaTypeStatusChartData?.FebInProcess,
            getSlaDashboardSlaTypeStatusChartData?.MarInProcess,
            getSlaDashboardSlaTypeStatusChartData?.AprInProcess,
            getSlaDashboardSlaTypeStatusChartData?.MayInProcess,
            getSlaDashboardSlaTypeStatusChartData?.JunInProcess,
            getSlaDashboardSlaTypeStatusChartData?.JulInProcess,
            getSlaDashboardSlaTypeStatusChartData?.AugInProcess,
            getSlaDashboardSlaTypeStatusChartData?.SepInProcess,
            getSlaDashboardSlaTypeStatusChartData?.OctInProcess,
            getSlaDashboardSlaTypeStatusChartData?.NovInProcess,
            getSlaDashboardSlaTypeStatusChartData?.DecInProcess
            ],
            backgroundColor: 'rgba(255, 94, 0, 1)', // Orange
            borderColor: 'rgba(255, 94, 0, 1)',
            borderWidth: 1,
            borderRadius: 4,
            barThickness: 8,
            borderSkipped: false,
        },
        {
            type: 'line',
            label: 'Completed',
            data: [getSlaDashboardSlaTypeStatusChartData?.JanCompleted,
            getSlaDashboardSlaTypeStatusChartData?.FebCompleted,
            getSlaDashboardSlaTypeStatusChartData?.MarCompleted,
            getSlaDashboardSlaTypeStatusChartData?.AprCompleted,
            getSlaDashboardSlaTypeStatusChartData?.MayCompleted,
            getSlaDashboardSlaTypeStatusChartData?.JunCompleted,
            getSlaDashboardSlaTypeStatusChartData?.JulCompleted,
            getSlaDashboardSlaTypeStatusChartData?.AugCompleted,
            getSlaDashboardSlaTypeStatusChartData?.SepCompleted,
            getSlaDashboardSlaTypeStatusChartData?.OctCompleted,
            getSlaDashboardSlaTypeStatusChartData?.NovCompleted,
            getSlaDashboardSlaTypeStatusChartData?.DecCompleted
            ],
            backgroundColor: (context) => {
                const chart = context.chart;
                const ctx = chart.ctx;
                const gradient = ctx.createLinearGradient(0, 0, 0, chart.height);
                gradient.addColorStop(0, 'rgba(58, 201, 119, 0.2)');
                gradient.addColorStop(1, 'rgba(58, 201, 119, 0)');
                return gradient;
            },
            borderColor: 'rgba(58, 201, 119, 1)',
            borderWidth: 2,
            fill: true,
            tension: 0.4,
        },

    ];

    const datasetsOfSlaChecklistStatus = [
        {
            type: 'bar',
            label: 'Hold',
            data: [getSlaDashboardChecklistStatusChartData?.JanOnHold,
            getSlaDashboardChecklistStatusChartData?.FebOnHold,
            getSlaDashboardChecklistStatusChartData?.MarOnHold,
            getSlaDashboardChecklistStatusChartData?.AprOnHold,
            getSlaDashboardChecklistStatusChartData?.MayOnHold,
            getSlaDashboardChecklistStatusChartData?.JunOnHold,
            getSlaDashboardChecklistStatusChartData?.JulOnHold,
            getSlaDashboardChecklistStatusChartData?.AugOnHold,
            getSlaDashboardChecklistStatusChartData?.SepOnHold,
            getSlaDashboardChecklistStatusChartData?.OctOnHold,
            getSlaDashboardChecklistStatusChartData?.NovOnHold,
            getSlaDashboardChecklistStatusChartData?.DecOnHold
            ],
            backgroundColor: 'rgba(240, 207, 43, 1)', // Yellow
            borderColor: 'rgba(240, 207, 43, 1)',
            borderWidth: 1,
            borderRadius: 4,
            barThickness: 8,
            borderSkipped: false,
        },
        {
            type: 'bar',
            label: 'Inprogress',
            data: [getSlaDashboardChecklistStatusChartData?.JanInProcess,
            getSlaDashboardChecklistStatusChartData?.FebInProcess,
            getSlaDashboardChecklistStatusChartData?.MarInProcess,
            getSlaDashboardChecklistStatusChartData?.AprInProcess,
            getSlaDashboardChecklistStatusChartData?.MayInProcess,
            getSlaDashboardChecklistStatusChartData?.JunInProcess,
            getSlaDashboardChecklistStatusChartData?.JulInProcess,
            getSlaDashboardChecklistStatusChartData?.AugInProcess,
            getSlaDashboardChecklistStatusChartData?.SepInProcess,
            getSlaDashboardChecklistStatusChartData?.OctInProcess,
            getSlaDashboardChecklistStatusChartData?.NovInProcess,
            getSlaDashboardChecklistStatusChartData?.DecInProcess
            ],
            backgroundColor: 'rgba(255, 94, 0, 1)', // Orange
            borderColor: 'rgba(255, 94, 0, 1)',
            borderWidth: 1,
            borderRadius: 4,
            barThickness: 8,
            borderSkipped: false,
        },
        {
            type: 'line',
            label: 'Completed',
            data: [getSlaDashboardChecklistStatusChartData?.JanCompleted,
            getSlaDashboardChecklistStatusChartData?.FebCompleted,
            getSlaDashboardChecklistStatusChartData?.MarCompleted,
            getSlaDashboardChecklistStatusChartData?.AprCompleted,
            getSlaDashboardChecklistStatusChartData?.MayCompleted,
            getSlaDashboardChecklistStatusChartData?.JunCompleted,
            getSlaDashboardChecklistStatusChartData?.JulCompleted,
            getSlaDashboardChecklistStatusChartData?.AugCompleted,
            getSlaDashboardChecklistStatusChartData?.SepCompleted,
            getSlaDashboardChecklistStatusChartData?.OctCompleted,
            getSlaDashboardChecklistStatusChartData?.NovCompleted,
            getSlaDashboardChecklistStatusChartData?.DecCompleted
            ],
            backgroundColor: (context) => {
                const chart = context.chart;
                const ctx = chart.ctx;
                const gradient = ctx.createLinearGradient(0, 0, 0, chart.height);
                gradient.addColorStop(0, 'rgba(58, 201, 119, 0.2)');
                gradient.addColorStop(1, 'rgba(58, 201, 119, 0)');
                return gradient;
            },
            borderColor: 'rgba(58, 201, 119, 1)',
            borderWidth: 2,
            fill: true,
            tension: 0.4,
        },

    ];

    const ticketDetailsDatasets = [
        {
            type: 'bar',
            label: 'Target Value',
            data: [getSlaDashboardSlaTypesChartData?.JanTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.FebTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.MarTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.AprTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.MayTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.JunTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.JulTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.AugTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.SepTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.OctTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.NovTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.DecTargetValueInPercentage
            ],
            backgroundColor: 'rgba(255, 94, 94, 1)', // Dark Red
            borderColor: 'rgba(255, 94, 94, 1)',
            borderWidth: 1,
            borderRadius: 4,
            barThickness: 8,
            borderSkipped: false,
        },
        {
            type: 'bar',
            label: 'Achieved Value',
            data: [getSlaDashboardSlaTypesChartData?.JanAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.FebAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.MarAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.AprAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.MayAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.JunAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.JulAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.AugAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.SepAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.OctAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.NovAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.DecAchievedValueInPercentage
            ],
            backgroundColor: 'rgba(58, 201, 119, 1)', // Bright Red
            borderColor: 'rgba(58, 201, 119, 1)',
            borderWidth: 1,
            borderRadius: 4,
            barThickness: 8,
            borderSkipped: false,
        }
    ];

    const chartOptions = {
        responsive: true,
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let label = context.dataset.label || '';
                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed.y !== null) {
                            label += `${context.parsed.y}`;
                        }
                        return label;
                    }
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    stepSize: 25,
                    callback: function (value) {
                        if (value === 0 || value === 25 || value === 50 || value === 75 || value === 100) {
                            return value;
                        }
                    }
                }
            },
            y: {
                beginAtZero: true
            }
        }
    };
    const dropdownOptions = {
        company: {
            default: 'Company Name',
            // items: [
            //     { value: 'Company Name', label: 'Company Name' },
            //     { value: 'Other Company', label: 'Other Company' },
            // ],
            items: getCompanyDropdown,
        },
        assignedTo: {
            default: 'Assigned To',
            // items: [
            //     { value: 'Assigned To1', label: 'Assigned To1' },
            //     { value: 'Assigned To2', label: 'Assigned To2' },
            // ],
            items: reportingToDropdown,
        },
        slaType: {
            default: 'Select Type',
            // items: [
            //     { value: 'Select Type1', label: 'Select Type1' },
            //     { value: 'Select Type2', label: 'Select Type2' },
            // ],
            items: assignedToSlaTypeDropdownData,
        },

        year: {
            default: 'Year',
            // items: [
            //     { value: '2023', label: '2023' },
            //     { value: '2024', label: '2024' },
            // ],
            items: generateYearRange(2022),
        },
    };

    const branchDropdownOptions = {
        company: {
            default: 'Company Name',
            items: [
                { value: 'Company Name', label: 'Company Name' },
                { value: 'Other Company', label: 'Other Company' },
            ],
        },
        assignedTo: {
            default: 'Assigned To',
            items: [
                { value: 'Assigned To1', label: 'Assigned To1' },
                { value: 'Assigned To2', label: 'Assigned To2' },
            ],
        },
        selectType: {
            default: 'Select Type',
            items: [
                { value: 'Select Type1', label: 'Select Type1' },
                { value: 'Select Type2', label: 'Select Type2' },
            ],
        },

        year: {
            default: 'Year',
            items: [
                { value: '2023', label: '2023' },
                { value: '2024', label: '2024' },
            ],
        },
    };

    const funnelColors = ['rgba(240, 207, 43, 1)', 'rgba(255, 94, 0, 1)', 'rgba(58, 201, 119, 1)'];
    const funnelLabels = ['Hold', 'Inprocess', 'Completed'];
    const funnelData = [
        { value: 200 },
        { value: 150 },
        { value: 100 },
    ];

    const handleBack = () => {
        const moduleId = 6;
        navigate('/sla', { state: { moduleId } })
    };

    const handleNavigation = () => {
        navigate('/sla')
    }

    const handleDashboardLibraryClick = () => {
        navigate('/dashboard-library')
    }

    const slaTypeBarChartRef = useRef(null);
    const assignedScoreChartRef = useRef(null);
    const totalSlaFunnelChartRef = useRef(null);
    const slaTypeStatusBarChartRef = useRef(null);
    const slaCheckListBarChartRef = useRef(null);

    const handleDownloadExcel = () => {
        slaTypeBarChartRef.current.handleDownloadExcel();
        assignedScoreChartRef.current.handleDownloadExcel();
        totalSlaFunnelChartRef.current.handleDownloadExcel();
        slaTypeStatusBarChartRef.current.handleDownloadExcel();
        slaCheckListBarChartRef.current.handleDownloadExcel();
    }

    const handleDownloadPDF = () => {
        slaTypeBarChartRef.current.handleDownloadPDF();
        assignedScoreChartRef.current.handleDownloadPDF();
        totalSlaFunnelChartRef.current.handleDownloadPDF();
        slaTypeStatusBarChartRef.current.handleDownloadPDF();
        slaCheckListBarChartRef.current.handleDownloadPDF();
    }

    const handleDownloadWord = () => {
        slaTypeBarChartRef.current.handleDownloadWord();
        assignedScoreChartRef.current.handleDownloadWord();
        totalSlaFunnelChartRef.current.handleDownloadWord();
        slaTypeStatusBarChartRef.current.handleDownloadWord();
        slaCheckListBarChartRef.current.handleDownloadWord();
    }

    const handlePrint = () => {
        slaTypeBarChartRef.current.handlePrint();
        assignedScoreChartRef.current.handlePrint();
        totalSlaFunnelChartRef.current.handlePrint();
        slaTypeStatusBarChartRef.current.handlePrint();
        slaCheckListBarChartRef.current.handlePrint();
    }

    const handleDownloadImage = () => {
        slaTypeBarChartRef.current.handleDownloadImage();
        assignedScoreChartRef.current.handleDownloadImage();
        totalSlaFunnelChartRef.current.handleDownloadImage();
        slaTypeStatusBarChartRef.current.handleDownloadImage();
        slaCheckListBarChartRef.current.handleDownloadImage();
    }

    const determineColumnSize = (visibleCols) => {
        if (visibleCols === 1) {
            return 12;  // One column takes the full width
        } else if (visibleCols === 2) {
            return 6;  // Two columns each take half the width
        } else if (visibleCols === 3) {
            return 4;  // Three columns each take a third of the width
        } else if (visibleCols >= 4) {
            return 3;  // Four or more columns each take a quarter of the width
        }
        return 4;  // Default fallback
    };

    return (
        <div className='dashboard-container'>
            <Main>
                {loading ? (
                    <div className="loading-container" style={{ position: 'absolute', top: '40%', left: '40%' }}>
                        <img src={loader} style={{ width: '180px' }} />
                    </div>
                ) : (
                    <>
                        <div className='components-download-container'>
                            <Download moduleName="Service Level Agreement Dashboard"
                                showBackButton={true}
                                showDashboardLibraryButton={true}
                                showSaveCustomViewButton={true}
                                showAnalyticsButton={false}
                                showDownloadDropdown={true}
                                showCustomViewDropdown={true}
                                onBackClick={handleBack}
                                onExcelDownloadClick={handleDownloadExcel}
                                onPdfDownloadClick={handleDownloadPDF}
                                onWordDownloadClick={handleDownloadWord}
                                onPrintClick={handlePrint}
                                onImageClick={handleDownloadImage}
                                onClick={handleDashboardLibraryClick}
                                customViews={customViews}
                                onCustomDashboardSelect={setSelectedDashboardID}
                            />
                        </div>
                        {/* <Row className='dashboard-cards-container'>
                    <Col md={3} className='p-0 dashboard-cards-cols'>
                        <div className='dashboard-cards' onClick={handleNavigation}>
                            <div className='dashboard-cards-counts'>
                                <p>Total SLA</p>
                                <b>{loading ? <Skeleton width={100} /> : getSlaDashboardCardData.TotalSLAs}</b>
                            </div>
                            <div className='dashboard-cards-image'>
                                <img src={totalSla} alt="" />
                            </div>
                        </div>
                    </Col>
                    <Col md={3} className='pe-0 dashboard-cards-cols'>
                        <div className='dashboard-cards' onClick={handleNavigation}>
                            <div className='dashboard-cards-counts'>
                                <p>In-Process</p>
                                <b>{loading ? <Skeleton width={100} /> : getSlaDashboardCardData.InProcessSLAs}</b>
                            </div>
                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                <img src={inProcess} alt="" />
                            </div>
                        </div>
                    </Col>
                    <Col md={3} className='pe-0 dashboard-cards-cols'>
                        <div className='dashboard-cards' onClick={handleNavigation}>
                            <div className='dashboard-cards-counts'>
                                <p>Hold</p>
                                <b>{loading ? <Skeleton width={100} /> : getSlaDashboardCardData.OnHoldSLAs}</b>
                            </div>
                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 159, 0, 0.2)" }}>
                                <img src={hold} alt="" />
                            </div>
                        </div>
                    </Col>
                    <Col md={3} className='pe-0 dashboard-cards-cols'>
                        <div className='dashboard-cards' onClick={handleNavigation}>
                            <div className='dashboard-cards-counts'>
                                <p>Completed</p>
                                <b>{loading ? <Skeleton width={100} /> : getSlaDashboardCardData.CompletedSLAs}</b>
                            </div>
                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(58, 201, 119, 0.2)" }}>
                                <img src={completed} alt="" />
                            </div>
                        </div>
                    </Col>
                </Row> */}

                        <Row className='dashboard-cards-container'>
                            { // Case 1: customViews is empty → show all cards
                                (!customViews || customViews.length === 0 || (!selectedDashboardID && customViews[0]?.IsDefault === false)) ? (
                                    <>
                                        {/* Total Customer */}
                                        <Col md={3} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                            <div className='dashboard-cards'
                                            // onClick={handleNavigation}
                                            >
                                                <div className='dashboard-cards-counts'>
                                                    <p>Total SLA</p>
                                                    <b>{loading ? <Skeleton width={100} /> : getSlaDashboardCardData.TotalSLAs}</b>
                                                </div>
                                                <div className='dashboard-cards-image'>
                                                    <img src={totalSla} alt="" />
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Active / Inactive */}
                                        <Col md={3} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                            <div className='dashboard-cards'
                                            //  onClick={handleNavigation}
                                            >
                                                <div className='dashboard-cards-counts'>
                                                    <p>In-Process</p>
                                                    <b>{loading ? <Skeleton width={100} /> : getSlaDashboardCardData.InProcessSLAs}</b>
                                                </div>
                                                <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                                    <img src={inProcess} alt="" />
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Customer Under Validity */}
                                        <Col md={3} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                            <div className='dashboard-cards'
                                            // onClick={handleNavigation}
                                            >
                                                <div className='dashboard-cards-counts'>
                                                    <p>Hold</p>
                                                    <b>{loading ? <Skeleton width={100} /> : getSlaDashboardCardData.OnHoldSLAs}</b>
                                                </div>
                                                <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 159, 0, 0.2)" }}>
                                                    <img src={hold} alt="" />
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Customer License Expiration */}
                                        <Col md={3} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                            <div className='dashboard-cards' onClick={handleNavigation}>
                                                <div className='dashboard-cards-counts'>
                                                    <p>Completed</p>
                                                    <b>{loading ? <Skeleton width={100} /> : getSlaDashboardCardData.CompletedSLAs}</b>
                                                </div>
                                                <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(58, 201, 119, 0.2)" }}>
                                                    <img src={completed} alt="" />
                                                </div>
                                            </div>
                                        </Col>
                                    </>
                                ) : (
                                    // Case 2: customViews is not empty → show based on GraphLibraryID
                                    customViews?.map((view, viewIndex) => {
                                        let visibleCols = 0;

                                        // Count how many graphs are visible based on conditions
                                        view.Graphs.forEach((graph) => {
                                            if (graph.GraphLibraryID === 30) visibleCols += 1;
                                            if (graph.GraphLibraryID === 31) visibleCols += 1;
                                            if (graph.GraphLibraryID === 32) visibleCols += 1;
                                            if (graph.GraphLibraryID === 33) visibleCols += 1;
                                        });

                                        const columnSize = determineColumnSize(visibleCols); // Calculate `md` value based on visible columns

                                        return view.Graphs?.map((graph, index) => {
                                            if (graph.GraphLibraryID === 30) {
                                                return (
                                                    <Col md={columnSize} key={index} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                                        <div className='dashboard-cards'
                                                        // onClick={handleNavigation}
                                                        >
                                                            <div className='dashboard-cards-counts'>
                                                                <p>Total SLA</p>
                                                                <b>{loading ? <Skeleton width={100} /> : getSlaDashboardCardData.TotalSLAs}</b>
                                                            </div>
                                                            <div className='dashboard-cards-image'>
                                                                <img src={totalSla} alt="" />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                );
                                            }

                                            if (graph.GraphLibraryID === 31) {
                                                return (
                                                    <Col md={columnSize} key={index} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                                        <div className='dashboard-cards'
                                                        //  onClick={handleNavigation}
                                                        >
                                                            <div className='dashboard-cards-counts'>
                                                                <p>In-Process</p>
                                                                <b>{loading ? <Skeleton width={100} /> : getSlaDashboardCardData.InProcessSLAs}</b>
                                                            </div>
                                                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                                                <img src={inProcess} alt="" />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                );
                                            }

                                            if (graph.GraphLibraryID === 32) {
                                                return (
                                                    <Col md={columnSize} key={index} className='p-0 pe-3 ps-1 dashboard-cards-cols'>
                                                        <div className='dashboard-cards'
                                                        // onClick={handleNavigation}
                                                        >
                                                            <div className='dashboard-cards-counts'>
                                                                <p>Hold</p>
                                                                <b>{loading ? <Skeleton width={100} /> : getSlaDashboardCardData.OnHoldSLAs}</b>
                                                            </div>
                                                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 159, 0, 0.2)" }}>
                                                                <img src={hold} alt="" />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                );
                                            }

                                            if (graph.GraphLibraryID === 33) {
                                                return (
                                                    <Col md={columnSize} key={index} className="p-0 pe-3 ps-1 dashboard-cards-cols">
                                                        <div className='dashboard-cards'>
                                                            <div className='dashboard-cards-counts'>
                                                                <p>Completed</p>
                                                                <b>{loading ? <Skeleton width={100} /> : getSlaDashboardCardData.CompletedSLAs}</b>
                                                            </div>
                                                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(58, 201, 119, 0.2)" }}>
                                                                <img src={completed} alt="" />
                                                            </div>
                                                        </div>
                                                    </Col>
                                                );
                                            }

                                            return null; // If no matching GraphLibraryID, return nothing
                                        });
                                    })
                                )}
                        </Row>
                        {/* <Row className='dashboard-charts'>
                    <Col md={6} className='dashboard-charts-div p-0 '>
                        <div className='charts-container'>
                            <AttendanceStatusChart
                                moduleName="SLA Types"
                                labels={ComplaintLabels}
                                datasets={ticketDetailsDatasets}
                                dropdownOptions={dropdownOptions}
                                selectedOption={selectedOptionForSlaType}
                                handleSelect={(eventKey, type) => handleSelect(eventKey, type, 'SlaTypes')}
                                // defaultSelection={{ company: 'Company Name', year: 'Year' }}
                                ref={slaTypeBarChartRef}
                            />
                        </div>
                    </Col>
                    <Col md={3} className='dashboard-charts-div p-0 '>
                        <div className='charts-container'>
                            <RelationshipTypeChart
                                moduleName="Assigned Score"
                                labels={labels}
                                colors={colors}
                                data={data}
                                showYear={true}
                                showAssignedTo={true}
                                showCompany={true}
                                ref={assignedScoreChartRef}
                            />
                        </div>
                    </Col>
                    <Col md={3} className='dashboard-charts-div p-0 pe-4'>
                        <div style={{ height: "100%" }}>
                            <FunnelChart
                                moduleName="Total SLA" colors={funnelColors} labels={funnelLabels} data={funnelData} ref={totalSlaFunnelChartRef}
                            />
                        </div>
                    </Col>
                </Row> */}

                        <Row className='dashboard-charts'>
                            {/* Case 1: customViews is empty → show all cards */}
                            {(!customViews || customViews.length === 0 || (!selectedDashboardID && customViews[0]?.IsDefault === false)) ? (
                                (() => {
                                    const charts = [
                                        {
                                            id: 34, component: (
                                                <div className='charts-container  pe-2 ps-1'>
                                                    <AttendanceStatusChart
                                                        moduleName="SLA Types"
                                                        labels={ComplaintLabels}
                                                        datasets={ticketDetailsDatasets}
                                                        dropdownOptions={dropdownOptions}
                                                        selectedOption={selectedOptionForSlaType}
                                                        handleSelect={(eventKey, type) => handleSelect(eventKey, type, 'SlaTypes')}
                                                        // defaultSelection={{ company: 'Company Name', year: 'Year' }}
                                                        ref={slaTypeBarChartRef}
                                                    />
                                                </div>
                                            )
                                        },
                                        {
                                            id: 35, component: (
                                                <div className='charts-container  pe-2 ps-1'>
                                                    <RelationshipTypeChart
                                                        moduleName="Assigned Score"
                                                        labels={labels}
                                                        colors={colors}
                                                        data={data}
                                                        showYear={true}
                                                        showAssignedTo={true}
                                                        showCompany={true}
                                                        ref={assignedScoreChartRef}
                                                    />
                                                </div>
                                            )
                                        },
                                        {
                                            id: 36, component: (
                                                <div className='charts-container  pe-2 ps-1'>
                                                    <FunnelChart
                                                        moduleName="Total SLA" colors={funnelColors} labels={funnelLabels} data={funnelData} ref={totalSlaFunnelChartRef}
                                                    />
                                                </div>
                                            )
                                        }
                                    ];

                                    return charts.map(({ id, component }, index) => {
                                        let colSize = 12;
                                        if (charts.length === 2) colSize = 6;
                                        if (charts.length === 3) colSize = id === 34 ? 6 : 3;

                                        return (
                                            <Col
                                                key={id}
                                                xs={12}
                                                sm={12}
                                                md={colSize}
                                                lg={colSize}
                                                className={`dashboard-charts-div p-0 ${id === 17 ? 'pe-1' : ''}`}
                                            >
                                                <div className='charts-container' style={{ height: '100%' }}>
                                                    {component}
                                                </div>
                                            </Col>
                                        );
                                    });
                                })()
                            ) : (
                                // Case 2: customViews is not empty → show based on GraphLibraryID
                                customViews.map((view, viewIndex) => {
                                    const visibleGraphs = view.Graphs?.filter(graph =>
                                        [34, 35, 36].includes(graph.GraphLibraryID)
                                    ) || [];

                                    return visibleGraphs.map((graph, index) => {
                                        const id = graph.GraphLibraryID;

                                        // let colSize = 12;
                                        // if (visibleGraphs.length === 2) colSize = 6;
                                        // if (visibleGraphs.length === 3) colSize = id === 34 ? 6 : 3;

                                        let colSize = 12;
                                        if (id === 35) {
                                            colSize = 3; // Always 3 for Relationship Type
                                        } else if (visibleGraphs.length === 2) {
                                            colSize = 6;
                                        } else if (visibleGraphs.length === 3) {
                                            colSize = id === 34 ? 6 : 3;
                                        }

                                        let chartComponent = null;

                                        if (id === 34) {
                                            chartComponent = (
                                                <div className='charts-container  pe-2 ps-1'>
                                                    <AttendanceStatusChart
                                                        moduleName="SLA Types"
                                                        labels={ComplaintLabels}
                                                        datasets={ticketDetailsDatasets}
                                                        dropdownOptions={dropdownOptions}
                                                        selectedOption={selectedOptionForSlaType}
                                                        handleSelect={(eventKey, type) => handleSelect(eventKey, type, 'SlaTypes')}
                                                        // defaultSelection={{ company: 'Company Name', year: 'Year' }}
                                                        ref={slaTypeBarChartRef}
                                                    />
                                                </div>
                                            );
                                        }

                                        if (id === 35) {
                                            chartComponent = (
                                                <div className='charts-container  pe-2 ps-1'>
                                                    <RelationshipTypeChart
                                                        moduleName="Assigned Score"
                                                        labels={labels}
                                                        colors={colors}
                                                        data={data}
                                                        showYear={true}
                                                        showAssignedTo={true}
                                                        showCompany={true}
                                                        ref={assignedScoreChartRef}
                                                    />
                                                </div>
                                            );
                                        }

                                        if (id === 36) {
                                            chartComponent = (
                                                <div className='charts-container  pe-2 ps-1'>
                                                    <FunnelChart
                                                        moduleName="Total SLA" colors={funnelColors} labels={funnelLabels} data={funnelData} ref={totalSlaFunnelChartRef}
                                                    />
                                                </div>
                                            );
                                        }

                                        return (
                                            <Col
                                                key={index}
                                                xs={12}
                                                sm={12}
                                                md={colSize}
                                                lg={colSize}
                                                className={`dashboard-charts-div p-0 ${id === 7 ? 'pe-1' : ''}`}
                                            >
                                                <div className='charts-container' style={{ height: '100%' }}>
                                                    {chartComponent}
                                                </div>
                                            </Col>
                                        );
                                    });
                                })
                            )}
                        </Row>
                        {/* <Row className='dashboard-charts pt-4 pb-4'>
                    <Col md={6} className='dashboard-charts-div p-0'>
                        <div className='charts-container'>
                            <AttendanceStatusChart
                                moduleName="SLA Type Status"
                                labels={ComplaintLabels}
                                datasets={datasets}
                                dropdownOptions={dropdownOptions}
                                selectedOption={selectedOptionForSlaTypeStatus}
                                handleSelect={(eventKey, type) => handleSelect(eventKey, type, 'SlaTypesStatus')}
                                // defaultSelection={{ ticketType: 'Ticket Type', company: 'Company Name', year: 'Year' }}
                                ref={slaTypeStatusBarChartRef}
                            />
                        </div>
                    </Col>
                    <Col md={6} className='dashboard-charts-div p-0 pe-2'>
                        <div className='charts-container'>
                            <AttendanceStatusChart
                                moduleName="SLA Checklist Status"
                                labels={ComplaintLabels}
                                datasets={datasetsOfSlaChecklistStatus}
                                dropdownOptions={dropdownOptions}
                                selectedOption={selectedOptionForSlaChecklistStatus}
                                handleSelect={(eventKey, type) => handleSelect(eventKey, type, 'SlaChecklistStatus')}
                                // defaultSelection={{ company: 'Company Name', year: 'Year' }}
                                ref={slaCheckListBarChartRef}
                            />
                        </div>
                    </Col>
                </Row> */}

                        <Row className='dashboard-charts pt-4 pb-4'>
                            {(!customViews || customViews.length === 0 || (!selectedDashboardID && customViews[0]?.IsDefault === false)) ? (
                                (() => {
                                    const charts = [
                                        {
                                            id: 37,
                                            component: (
                                                <div className='charts-container pe-2 ps-1 '>
                                                    <AttendanceStatusChart
                                                        moduleName={customViews?.[0]?.DashboardName || "SLA Type Status"}
                                                        labels={ComplaintLabels}
                                                        datasets={datasets}
                                                        dropdownOptions={dropdownOptions}
                                                        selectedOption={selectedOptionForSlaTypeStatus}
                                                        handleSelect={(eventKey, type) => handleSelect(eventKey, type, 'SlaTypesStatus')}
                                                        // defaultSelection={{ ticketType: 'Ticket Type', company: 'Company Name', year: 'Year' }}
                                                        ref={slaTypeStatusBarChartRef}
                                                    />
                                                </div>
                                            )
                                        },
                                        {
                                            id: 38,
                                            component: (
                                                <div className='charts-container pe-2 ps-1 '>
                                                    <AttendanceStatusChart
                                                        moduleName="SLA Checklist Status"
                                                        labels={ComplaintLabels}
                                                        datasets={datasetsOfSlaChecklistStatus}
                                                        dropdownOptions={dropdownOptions}
                                                        selectedOption={selectedOptionForSlaChecklistStatus}
                                                        handleSelect={(eventKey, type) => handleSelect(eventKey, type, 'SlaChecklistStatus')}
                                                        // defaultSelection={{ company: 'Company Name', year: 'Year' }}
                                                        ref={slaCheckListBarChartRef}
                                                    />
                                                </div>
                                            )
                                        },
                                    ];

                                    const count = charts.length;

                                    return charts.map(({ id, component }) => {
                                        let colSize = 12;
                                        // if (count === 2) colSize = 6;
                                        if (count === 2) colSize = id === 37 ? 6 : 6;

                                        return (
                                            <Col
                                                key={id}
                                                xs={12}
                                                sm={12}
                                                md={colSize}
                                                lg={colSize}
                                                className='dashboard-charts-div p-0'
                                            >
                                                <div className='charts-container' style={{ height: '100%' }}>
                                                    {component}
                                                </div>
                                            </Col>
                                        );
                                    });
                                })()
                            ) : (
                                customViews.map((view, viewIndex) => {
                                    const visibleGraphs = view.Graphs?.filter(graph =>
                                        [37, 38].includes(graph.GraphLibraryID)
                                    ) || [];

                                    return visibleGraphs.map((graph, index) => {
                                        const id = graph.GraphLibraryID;

                                        let colSize = 12;
                                        // if (visibleGraphs.length === 2) colSize = 6;
                                        if (visibleGraphs.length === 2) colSize = id === 37 ? 6 : 6;

                                        let chartComponent = null;

                                        if (id === 37) {
                                            chartComponent = (
                                                <div className='charts-container pe-2 ps-1'>
                                                    <AttendanceStatusChart
                                                        moduleName="SLA Type Status"
                                                        labels={ComplaintLabels}
                                                        datasets={datasets}
                                                        dropdownOptions={dropdownOptions}
                                                        selectedOption={selectedOptionForSlaTypeStatus}
                                                        handleSelect={(eventKey, type) => handleSelect(eventKey, type, 'SlaTypesStatus')}
                                                        // defaultSelection={{ ticketType: 'Ticket Type', company: 'Company Name', year: 'Year' }}
                                                        ref={slaTypeStatusBarChartRef}
                                                    />
                                                </div>
                                            );
                                        }

                                        if (id === 38) {
                                            chartComponent = (
                                                <div className='charts-container pe-2 ps-1'>
                                                    <AttendanceStatusChart
                                                        moduleName="SLA Checklist Status"
                                                        labels={ComplaintLabels}
                                                        datasets={datasetsOfSlaChecklistStatus}
                                                        dropdownOptions={dropdownOptions}
                                                        selectedOption={selectedOptionForSlaChecklistStatus}
                                                        handleSelect={(eventKey, type) => handleSelect(eventKey, type, 'SlaChecklistStatus')}
                                                        // defaultSelection={{ company: 'Company Name', year: 'Year' }}
                                                        ref={slaCheckListBarChartRef}
                                                    />
                                                </div>
                                            );
                                        }

                                        return (
                                            <Col
                                                key={index}
                                                xs={12}
                                                sm={12}
                                                md={colSize}
                                                lg={colSize}
                                                className='dashboard-charts-div p-0'
                                            >
                                                <div className='charts-container' style={{ height: '100%' }}>
                                                    {chartComponent}
                                                </div>
                                            </Col>
                                        );
                                    });
                                })
                            )}
                        </Row>
                    </>
                )}
            </Main>
        </div>
    )
}

export default ServiceLevelAgreementDashboard;

